function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ativoA {\n                fill: #adce6b;\n                stroke: #fff;\n                stroke-width: 3px;\n            }\n\n            .b {\n                stroke: none;\n            }\n\n            .c {\n                fill: none;\n            }\n\n            .d {\n                filter: url(#a);\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 0,
  y: 0,
  width: 38,
  height: 38,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8 8)"
}, /*#__PURE__*/React.createElement("g", {
  className: "d",
  transform: "matrix(1, 0, 0, 1, -9, -6)"
}, /*#__PURE__*/React.createElement("g", {
  className: "ativoA",
  transform: "translate(9 6)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  className: "c",
  cx: 10,
  cy: 10,
  r: 8.5
}))));

var SvgAtivo = function SvgAtivo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtivo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ativo.756de440.svg";
export { ForwardRef as ReactComponent };